import ApiClient from './ApiClient';

class ProductsAPI extends ApiClient {
  constructor() {
    super('products', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  show(productId) {
    return axios.get(`${this.url}/${productId}`);
  }

  create(data) {
    return axios.post(this.url, data);
  }

  update(productId, data) {
    return axios.patch(`${this.url}/${productId}`, data);
  }

  delete(productId) {
    return axios.delete(`${this.url}/${productId}`);
  }

  // Gallery
  addGalleryImage(productId, formData) {
    return axios.post(`${this.url}/${productId}/add_gallery_image`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  removeGalleryImage(productId, imageId) {
    return axios.delete(
      `${this.url}/${productId}/remove_gallery_image?image_id=${imageId}`
    );
  }

  setMainPhoto(productId, imageId) {
    return axios.post(
      `${this.url}/${productId}/set_main_photo`,
      { image_id: imageId }
    );
  }

  reorderGallery(productId, imageIds) {
    return axios.post(
      `${this.url}/${productId}/reorder_gallery`,
      { image_ids: imageIds }
    );
  }

  // AI Image Search
  searchImage(productId) {
    return axios.post(`${this.url}/${productId}/search_image`);
  }

  bulkSearchImages(params = {}) {
    return axios.post(`${this.url}/bulk_search_images`, params);
  }

  // Subitems
  getSubitems(productId) {
    return axios.get(`${this.url}/${productId}/subitems`);
  }

  createSubitem(productId, data) {
    return axios.post(`${this.url}/${productId}/subitems`, data);
  }

  updateSubitem(productId, subitemId, data) {
    return axios.patch(`${this.url}/${productId}/subitems/${subitemId}`, data);
  }

  deleteSubitem(productId, subitemId) {
    return axios.delete(`${this.url}/${productId}/subitems/${subitemId}`);
  }

  reorderSubitems(productId, positions) {
    return axios.post(`${this.url}/${productId}/subitems/reorder`, {
      positions,
    });
  }

  // Subitem Photos
  addSubitemPhoto(productId, subitemId, photo) {
    const formData = new FormData();
    formData.append('photo', photo);
    return axios.post(
      `${this.url}/${productId}/subitems/${subitemId}/add_photo`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
  }

  removeSubitemPhoto(productId, subitemId, photoId) {
    return axios.delete(
      `${this.url}/${productId}/subitems/${subitemId}/remove_photo?photo_id=${photoId}`
    );
  }
}

export default new ProductsAPI();
